import axios from "axios";
import { useState } from "react";
import styled from "styled-components";

const Container = styled.div``;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;

  gap: 10px;
  margin-top: 10px;

  button {
    margin: 0;
    border-radius: 3px;
  }
`;

const Tax = styled.div`
  background: grey;
  color: white;
  padding: 5px;
  font-size: 20px;
  font-weight: 900;
  border-radius: 3px;
  text-align: center;
`;

const Loading = styled.div`
  padding: 10px;
`;

const e = {
  target: {
    value: null,
    name: null,
  },
};

const TaxAPI = ({ street, city, state, zip, editDocument, tax, doc }) => {
  const [post, setPost] = useState(null);
  const [calling, setCalling] = useState(null);
  const [manual, setManual] = useState(false);

  const callAPI = (street, city, state, zip) => {
    var options = {
      method: "POST",
      url: "https://sales-tax-calculator.p.rapidapi.com/rates",
      headers: {
        "x-rapidapi-host": "sales-tax-calculator.p.rapidapi.com",
        "x-rapidapi-key": "fc1b6b561emshcfee51ca2af0128p11917ejsn0d19d97fe03a",
      },
      data: {
        street: street,
        city: city,
        state: state,
        zip: zip,
      },
    };
    axios
      .request(options)
      .then(function (response) {
        setPost(response.data);
        if (!response.data.message) {
          e.target.value = response.data.tax_rate;
          e.target.name = "tax";
          editDocument(doc, "tax", response.data.tax_rate);
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const handleCall = () => {
    setManual(false);
    setPost(null);
    callAPI(street, city, state, zip);
    setCalling(true);
  };

  const mainView = (
    <Container>
      {(manual && (
        <input
          className="form-control"
          type="number"
          name="tax"
          onChange={(e) => editDocument(doc, e.target.name, e.target.value)}
          autoComplete="off"
        />
      )) || <Tax>{tax}%</Tax>}
      <Buttons>
        <button onClick={() => handleCall()}>call</button>
        <button onClick={() => setManual(!manual)}>
          {(manual && "save") || "manual"}
        </button>
      </Buttons>
    </Container>
  );

  if (!calling) {
    return mainView;
  } else if (!post) {
    return (
      <>
        <Loading>loading...</Loading>
        {mainView}
      </>
    );
  } else if (post.message) {
    return (
      <>
        <Loading>{post.message}</Loading>
        {mainView}
      </>
    );
  } else {
    return mainView;
  }
};

export default TaxAPI;
